module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp12_8023.a8d1a488.png";